import React from "react";
import { MultiSelect } from "primereact/multiselect";
import useFetchData from "hooks/useFetchDataWithDep";
import Loading from "Components/Loading/Loading";
import Translate from "Components/Translate";
import {
    TAXIS,
    DRIVERS,
  } from "Constant";

const TripsFilters = ({ selectedDrivers, setSelectedDrivers, selectedTaxis, setSelectedTaxis }) => {
    const { data: driversData, isLoading: isLoadingDrivers } = useFetchData('/front/driversChoices');
    const { data: taxisData, isLoading: isLoadingTaxis } = useFetchData('/front/taxisChoices');

   // if (isLoadingDrivers || isLoadingTaxis) return <Loading />;

    console.log('driversData complet:', driversData);
    console.log('driversData?.data?.results:', driversData?.data?.results);
    console.log('driversData?.data?.results?.data:', driversData?.data?.results?.data);

    const drivers = driversData?.data?.results?.data?.map(driver => ({
        name: driver.label,
        code: driver.code
    })) || [];

    console.log('drivers après mapping:', drivers);

    const taxis = taxisData?.data?.results?.data?.map(taxi => ({
        name: taxi.label.split('/').pop().trim(),
        code: taxi.code,
        fullLabel: taxi.label
    })) || [];

    return (
        <div className="flex gap-2">
            <div className="card flex justify-content-center">
                <MultiSelect 
                    value={selectedDrivers} 
                    onChange={(e) => setSelectedDrivers(e.value)} 
                    options={drivers} 
                    optionLabel="name" 
                    filter 
                    placeholder=<Translate>{DRIVERS}</Translate>
                    maxSelectedLabels={3} 
                    className="w-full md:w-20rem"
                    selectionLimit={1}
                />
            </div>
            <div className="card flex justify-content-center">
                <MultiSelect 
                    value={selectedTaxis} 
                    onChange={(e) => setSelectedTaxis(e.value)} 
                    options={taxis} 
                    optionLabel="name"
                    filter 
                    placeholder=<Translate>{TAXIS}</Translate>
                    maxSelectedLabels={3} 
                    className="w-full md:w-20rem"
                    selectionLimit={1}
                />
            </div>
        </div>
    );
};

export default TripsFilters; 